var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("navbar"),
      _c("div", { staticClass: "content" }, [
        _c("h2", [_vm._v("礼包管理")]),
        _c("h3", [_vm._v("数据筛选")]),
        _c(
          "div",
          [
            _c(
              "el-form",
              {
                ref: "search",
                attrs: {
                  model: _vm.search,
                  inline: true,
                  id: "search",
                  size: "small",
                },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "礼包编码", prop: "code" } },
                  [
                    _c("el-input", {
                      attrs: { clearable: "", placeholder: "请输入礼包编码" },
                      model: {
                        value: _vm.search.code,
                        callback: function ($$v) {
                          _vm.$set(_vm.search, "code", $$v)
                        },
                        expression: "search.code",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "礼包名称", prop: "name" } },
                  [
                    _c("el-input", {
                      attrs: { clearable: "", placeholder: "请输入礼包名称" },
                      model: {
                        value: _vm.search.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.search, "name", $$v)
                        },
                        expression: "search.name",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "礼包支付方式", prop: "payType" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          placeholder: "请选择礼包支付方式",
                          clearable: "",
                        },
                        model: {
                          value: _vm.search.payType,
                          callback: function ($$v) {
                            _vm.$set(_vm.search, "payType", $$v)
                          },
                          expression: "search.payType",
                        },
                      },
                      _vm._l(
                        _vm.dictionaries.gift_package_pay_type,
                        function (item, index) {
                          return _c("el-option", {
                            key: item.dictId,
                            attrs: {
                              label: item.dictName,
                              value: item.dictId,
                              disabled: index !== 0,
                            },
                          })
                        }
                      ),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "平台", prop: "platformId" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "请选择平台", clearable: "" },
                        model: {
                          value: _vm.search.platformId,
                          callback: function ($$v) {
                            _vm.$set(_vm.search, "platformId", $$v)
                          },
                          expression: "search.platformId",
                        },
                      },
                      _vm._l(_vm.platformListFilter, function (item) {
                        return _c("el-option", {
                          key: item.id,
                          attrs: { label: item.name, value: item.id },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "状态", prop: "status" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "请选择状态", clearable: "" },
                        model: {
                          value: _vm.search.status,
                          callback: function ($$v) {
                            _vm.$set(_vm.search, "status", $$v)
                          },
                          expression: "search.status",
                        },
                      },
                      _vm._l(_vm.dictionaries.enable_status, function (item) {
                        return _c("el-option", {
                          key: item.dictId,
                          attrs: { label: item.dictName, value: item.dictId },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "礼包类目", prop: "status" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "请选择类目", clearable: "" },
                        model: {
                          value: _vm.search.categoryNos,
                          callback: function ($$v) {
                            _vm.$set(_vm.search, "categoryNos", $$v)
                          },
                          expression: "search.categoryNos",
                        },
                      },
                      _vm._l(_vm.firstCategory, function (item) {
                        return _c("el-option", {
                          key: item.categoryNo,
                          attrs: {
                            label: item.categoryName,
                            value: item.categoryNo,
                          },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.fetchData("search", true)
                          },
                        },
                      },
                      [_vm._v("查询")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", plain: "" },
                        on: {
                          click: function ($event) {
                            return _vm.fetchData("reset")
                          },
                        },
                      },
                      [_vm._v("重置")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("h3", { staticClass: "data-list-title" }, [
            _vm._v("数据列表 "),
            _c(
              "p",
              [
                _c("span", [
                  _vm._v("个人复购佣金：" + _vm._s(_vm.commissionNum) + "%"),
                ]),
                _c(
                  "el-link",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.setCommission },
                  },
                  [_vm._v("设置")]
                ),
                _vm.parArray.indexOf("addPlatform") != -1
                  ? _c(
                      "el-button",
                      {
                        attrs: { size: "small", type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.showDialog("新增", "add")
                          },
                        },
                      },
                      [_vm._v("新增")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _c("matrix-table", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.manage.loading,
                expression: "manage.loading",
              },
            ],
            attrs: {
              dataList: _vm.manage.page.list,
              config: _vm.manage.config,
              sortObj: _vm.manage.page.sortObj,
              platformListObj: _vm.platformListFilter,
            },
            on: { receiveData: _vm.showDetailData },
          }),
          _vm.manage.page.list.length > 0
            ? _c("el-pagination", {
                attrs: {
                  background: "",
                  "current-page": _vm.manage.page.pageNo,
                  "page-sizes": [3, 5, 10, 20, 50],
                  "page-size": _vm.manage.page.pageSize,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.manage.page.totalNum,
                },
                on: {
                  "size-change": _vm.onSizeChange,
                  "current-change": _vm.onCurrentChange,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialog.title,
            visible: _vm.dialog.visible,
            width: _vm.dialog.width,
            "append-to-body": true,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.dialog, "visible", $event)
            },
          },
        },
        [
          _vm.dialog.type === "commission"
            ? [
                _c(
                  "div",
                  { staticClass: "set-commission" },
                  [
                    _c("span", [_vm._v("个人复购比例")]),
                    _c("el-input", {
                      staticClass: "commission-num",
                      on: {
                        input: function ($event) {
                          _vm.commissionNum = _vm.checkValue(
                            _vm.commissionNum,
                            2
                          )
                        },
                      },
                      model: {
                        value: _vm.commissionNum,
                        callback: function ($$v) {
                          _vm.commissionNum = $$v
                        },
                        expression: "commissionNum",
                      },
                    }),
                    _vm._v("% "),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "dialog-commission" },
                  [
                    _c("el-button", { on: { click: _vm.commissionCancel } }, [
                      _vm._v("取 消"),
                    ]),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.commissionSubmit },
                      },
                      [_vm._v("确 定")]
                    ),
                  ],
                  1
                ),
              ]
            : [
                _c("gift-form", {
                  ref: "giftForm",
                  attrs: { typeStr: _vm.dialog.type },
                  on: { dialogFromData: _vm.handleFromData },
                }),
              ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }